export default "__VITE_ASSET__BZ_hb1f3__"